import React, { useEffect, useState } from "react"
import SearchableSelect, { SearchableSelectOption } from "."
import api, {apiV2} from "../../../api/axiosConfig"
import { PaginatedResponse } from "../../../types/PaginatedResponse"
import { Client } from "../../../types/userManagement"
import SuitcaseIcon from "../../../assets/icons/suitcase.svg";

type ClientSelectParams = {
  clients: Client[]
  multiple?: boolean;
  onSelectionChange?: (clients: Client[]) => void;
  disabled?: boolean;
  icon?: boolean;
  module?: string;
}

function ClientSelect({
  multiple,
  onSelectionChange,
  clients,
  disabled,
  icon = true,
  module,
}: ClientSelectParams){

  const [loading, setLoading] = useState(false)
  const [options, setOptions]  = useState<SearchableSelectOption<Client>[]>([])
  const [searchStr, setSearchStr] = useState("")

  const fetchClients = async () => {
    setLoading(true)
    try{
      const params: Record<string, string | number> = { search: searchStr, rpp: 20 };
      if (module) params["module"] = module;
      const res = await apiV2.get<PaginatedResponse<Client>>("/clients", { params })
      setOptions(res.data.items.map((c) => ({
        label: c.name,
        value: c,
        key: c.id!
      })))

    } catch(e){
      console.error(e)
    }

    setLoading(false)
  }

  useEffect(() => {
    fetchClients()
  }, [searchStr, module])


  const onChange = (selected: SearchableSelectOption<Client>[]) => {
    if(onSelectionChange){
      onSelectionChange(selected.map(s => s.value))
    }
  }

  const onSearch = (value: string) => {
    setSearchStr(value);
  }

  return (<SearchableSelect
    icon={icon ? SuitcaseIcon : undefined}
    label={multiple ? "Clients" : "Client"}
    selected={clients.map(c => ({
      label: c.name,
      value: c,
      key: c.id!
    }))}
    search={true}
    multiple={multiple ? true : false}
    options={options}
    localSearch={false}
    onChange={onChange}
    onSearch={onSearch}
    loading={loading}
    disabled={disabled}
  />)
}

export default ClientSelect

type ClientSelectSingleProps = {
  client?: Client,
  onChange?: (selected: Client|undefined) => void,
  disabled?: boolean,
  initialClientID?: string,
  module?: string,
}

export const ClientSelectSingle: React.FC<ClientSelectSingleProps> = (props) =>
{

  const loadInitialClient = async () => {
    if(!props.initialClientID) return;
    const res = await apiV2.get<Client>(`clients/${props.initialClientID}`)
    if(props.onChange){
      props.onChange(res.data)
    }


  }

  useEffect(() => {
    loadInitialClient()
  }, []);


  const onChange = (clients: Client[]) => {
    if (!props.onChange) return;

    if(clients.length == 0){
      props.onChange(undefined)
      return
    }

    props.onChange(clients[0])
  }

  return <ClientSelect disabled={props.disabled} multiple={false} onSelectionChange={onChange} clients={props.client ? [props.client] : []} module={props.module}/>
}